module.exports = {
  account: { role: {} },
  setAccount: function (account) {
    this.account = account;
  }
};



// WEBPACK FOOTER //
// ./src/app/store.js